import type { GeneratedStoryWithImageUrls } from 'schemas';
import { GetGeneratedStoryResponseSchema } from 'schemas';
import { apiRequest } from '@/api/helpers/apiRequest';
import { handleApiError } from '@/api/helpers/handleApiError';

export const fetchGeneratedStory = async (
  storyId: string
): Promise<GeneratedStoryWithImageUrls> => {
  try {
    return await apiRequest(
      'GET',
      `/api/generated-stories/${storyId}`,
      undefined,
      GetGeneratedStoryResponseSchema
    );
  } catch (error) {
    handleApiError(error);
  }
};
